<template lang="pug">
span(v-if="name" :class="{'customer-name-link': link}" @click="onClick") 
  span {{ name }} 
  
  strong.tag.is-rounded.is-warning.is-size-7(v-if="showCard && customer.cardId" style="padding: 0 0.5rem; font-size: 0.75em !important") \#{{ customer.cardId}}
  b-tooltip(v-if="showIsNew && !customer.sales" append-to-body position="is-top" :label="$t('appointment.new_client')") 
    span.icon
      i.mdi.mdi-new-box
span.has-text-grey(v-else) {{ $t('misc.unknown') }} 
</template>
<script>
import {mapActions} from 'vuex'
import CustomerDetailsMobile from './CustomerDetailsMobile.vue'
import Details from './Details.vue'
export default {
  name: 'CustomerNameView',
  props: {
    value: {type: [Object, String], default: undefined},
    link: {type: Boolean, default: false},
    showIsNew: {type: Boolean, default: false},
    showCard: {type: Boolean, default: true},
    showPhone: {type: Boolean, default: false}
  },
  data() {
    return {
      customer: undefined
    }
  },
  computed: {
    name() {
      if (!this.customer) {
        return
      }
      if (!this.customer.firstName && !this.customer.lastName && this.showPhone && this.customer.phone) {
        return this.customer.phone
      }
      return [this.customer.firstName, this.customer.middleName, this.customer.lastName].filter(c => c).join(' ')
    }
  },
  watch: {
    value() {
      this.init()
    }
  },
  async created() {
    await this.init()
  },
  methods: {
    ...mapActions('customers', ['fetchCustomer']),
    async init() {
      if (this.value && typeof this.value === 'string') {
        this.customer = await this.fetchCustomer(this.value)
      } else {
        this.customer = this.value
      }
    },
    onClick() {
      if (!this.link) {
        return
      }
      this.$buefy.modal.open({
        parent: this,
        component: this.isMobile() ? CustomerDetailsMobile : Details,
        hasModalCard: true,
        fullScreen: true,
        props: {customerId: this.customer._id || this.value},
        canCancel: ['escape', 'outside']
      })
    }
  }
}
</script>
